import Vue from 'vue'
import VueRouter from 'vue-router'
import { parseHashParams } from '../utils/params.js'
import { requiresPassword, isPasswordVerified } from '../utils/auth.js'

Vue.use(VueRouter)

import LaunchPage from '../views/LaunchPage/LaunchPage.vue'
import LoadingPage from '../views/Loading/Loading.vue'
import IndexPage from '../views/index/index.vue'

function redirectToHome() {
  const params = parseHashParams()
  const id = params.modelNum || ''
  return `/?userId=${id}&modelNum=${id}`
}

function requireFromPath(expectedPath) {
  return (to, from, next) => {
    if (from.path === expectedPath) {
      next()
    } else {
      next(redirectToHome())
    }
  }
}

const routes = [
  {
    path: '/password',
    component: () => import('../views/PasswordGate/PasswordGate.vue'),
  },
  {
    path: '/',
    component: LaunchPage,
    beforeEnter(to, from, next) { next() },
  },
  {
    path: '/ModulesLoding',
    component: LoadingPage,
    beforeEnter: requireFromPath('/'),
  },
  {
    path: '/Instruction',
    component: () => import('../views/Instruction/index.vue'),
    beforeEnter: requireFromPath('/'),
  },
  {
    path: '/index',
    component: IndexPage,
    beforeEnter: requireFromPath('/ModulesLoding'),
  },
  {
    path: '/SurgicalPlanningReport',
    component: () => import('../views/SurgicalPlanningReport/SurgicalPlanningReport'),
  },
  {
    path: '/PDF',
    component: () => import('../views/PDF/PDF'),
    beforeEnter: requireFromPath('/'),
  },
  {
    path: '/DICOM',
    component: () => import('../views/DICOM/DICOM'),
  },
  {
    path: '/Measure',
    component: () => import('../views/Measure/Measure'),
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.path === '/password') {
    return next()
  }
  if (requiresPassword() && !isPasswordVerified()) {
    const params = parseHashParams()
    const id = params.modelNum || ''
    return next({ path: '/password', query: { redirect: to.fullPath, modelNum: id } })
  }
  next()
})

export default router
